module.exports = __webpack_public_path__ + "static/img/PC-3.614e6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-3.png
// module id = z/KO
// module chunks = 0